<script lang="ts" setup>
defineProps<{
  popup?: boolean
  signup?: boolean
}>()

function onSignin() {
  window.dispatchEvent(new Event('show-auth-prompt-signin'))
}

function onSignup() {
  window.dispatchEvent(new Event('show-auth-prompt-signup'))
}

const selected = 'border-b-2 border-blurple-600 text-blurple-600'
const deslected = 'border-b mb-[0.5px] border-gray-600 text-gray-600'
</script>

<template>
  <div class="grid grid-cols-2 max-w-[675px] m-auto mt-4 md:mt-16 text-center">
    <div :class="'w-full p-2 ' + (!signup ? selected : deslected)">
      <PLink
        v-if="popup"
        id="signin-tab"
        href="#"
        class="w-full p-4 hover:text-blurple-600"
        :click="onSignin"
      >
        {{ $t('signin') }}
      </PLink>
      <PLink
        v-else
        id="signin-tab"
        to="/signin"
        class="w-full p-4 hover:text-blurple-600"
      >
        {{ $t('signin') }}
      </PLink>
    </div>
    <div :class="'w-full p-2 ' + (signup ? selected : deslected)">
      <PLink
        v-if="popup"
        id="signup-tab"
        href="#"
        class="w-full p-4 hover:text-blurple-600"
        :click="onSignup"
      >
        <span class="hidden md:inline">
          {{ $t('createProfile') }}
        </span>
        <span class="md:hidden">
          {{ $t('signup') }}
        </span>
      </PLink>
      <PLink
        v-else
        id="signup-tab"
        to="/signup"
        class="w-full p-4 hover:text-blurple-600"
      >
        <span class="hidden md:inline">
          {{ $t('createProfile') }}
        </span>
        <span class="md:hidden">
          {{ $t('signup') }}
        </span>
      </PLink>
    </div>
  </div>
</template>
